import { useState, Fragment, useEffect } from 'react';
import { Link, useNavigate, Navigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import Logo from 'assets/icons/finefinders-logo.svg';
import { PAGE_PATHS } from '../../constants';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { userStateSelector } from '../../store/selectors';
import { useReduxActions } from 'hooks/useReduxActions';

function Register() {
  const userState = useSelector(userStateSelector);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const actions = useReduxActions();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [hasRegistered, setHasRegistered] = useState(false);

  const handleSubmit = () => {
    actions.signUp({
      email,
      password,
    });
  };

  const handleLogin = () => {
    navigate(PAGE_PATHS.LOGIN);
  };

  useEffect(() => {
    if (userState.isSignUpLoading) {
      toast.loading(t('register.toast.loading.message'));
    }
    if (userState.error) {
      toast.dismiss();
      toast.error(userState.error.message);
    }
    if (userState.isSignUpSuccess) {
      toast.dismiss();
      toast.success(t('register.toast.success.message'));
      setHasRegistered(true);
    }
  }, [userState]); // eslint-disable-line

  if (userState.isLoggedIn) {
    return <Navigate to={PAGE_PATHS.PRODUCT} />;
  }

  return (
    <div className="login">
      <div className="side" />
      <div className="container">
        <div className="content-container mb">
          <img alt="Logo" src={Logo} />
          <p className="title">
            {!hasRegistered
              ? t('register.title.sign.up')
              : t('register.title.confirm.email')}
          </p>
          {!hasRegistered ? (
            <Fragment>
              <div className="input-container">
                <label>{t('register.email.label')}</label>
                <input
                  type="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                />
              </div>
              <div className="input-container">
                <label>{t('register.password.label')}</label>
                <input
                  type="password"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                />
                <p className="info">{t('register.info.text')}</p>
              </div>
              <div className="button-container">
                <button className="button" onClick={handleSubmit}>
                  {t('register.sign.up.button')}
                </button>
              </div>
              <p className="bottom note" style={{ bottom: 128 }}>
                {t('register.already.have.account')}
                <Link to={PAGE_PATHS.LOGIN}>{t('register.login.link')}</Link>
              </p>
            </Fragment>
          ) : (
            <div className="email-info-box">
              <p>{t('register.confirm.link.text')}</p>
              <p>{t('register.confirm.your.registration')}</p>
              <button type="button" onClick={handleLogin}>
                {t('register.login.button')}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Register;
